import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { SideDrawerListItem } from "../__shared__/SideDrawerListItem/SideDrawerListItem";
import { useState } from "react";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { useCleanBeauty } from "@/hooks/useCleanBeauty/useCleanBeauty";
import { LoadingSpinner } from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import styles from "@/components/ProductSideDrawers/GoodToKnow/GoodToKnow.module.scss";
import { Badges } from "@/components/ProductSideDrawers/GoodToKnow/components/Badges/Badges.tsx";
import { FreeFrom } from "@/components/ProductSideDrawers/GoodToKnow/components/FreeFrom/FreeFrom.tsx";

type GoodToKnowProps = {
  ean: string;
  cleanBeautyBaseUrl: string;
};

export function GoodToKnowUI({ ean, cleanBeautyBaseUrl }: GoodToKnowProps) {
  const [isOpen, setIsOpen] = useState(false);
  const cleanBeauty = useCleanBeauty(ean, cleanBeautyBaseUrl);

  if (["Error", "No action"].includes(cleanBeauty.status)) {
    return null;
  }

  if (cleanBeauty.status === "Done") {
    if (
      cleanBeauty.data?.free_From.length === 0 &&
      cleanBeauty.data?.labels.length === 0
    ) {
      return null;
    }
  }

  return (
    <>
      <SideDrawerListItem
        label="Good to know"
        onClick={() => {
          setIsOpen(true);
        }}
        trailingIcon={<ChevronRight size="medium" />}
      />
      <SEOFriendlyDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        heading={"Good to know"}
        primaryButtonText="Continue shopping"
      >
        {cleanBeauty.status === "Loading" && <LoadingSpinner />}
        {cleanBeauty.status === "Done" && (
          <section
            data-testid="good-to-know"
            className={styles.goodToKnowWrapper}
          >
            <p className={styles.text}>
              Useful information on how this product is good for the environment
              and for you.
            </p>
            <Badges badges={cleanBeauty.data?.labels || []}></Badges>
            <FreeFrom freeFrom={cleanBeauty.data?.free_From || []} />
            <div className={styles.poweredBy}>
              <h3 className={styles.disclaimer}>Disclaimer:</h3>
              The free from list and conscious beauty labels are provided by
              Skin Match Technology for information purposes only. Formulation
              and ingredients are subject to change by the brand. Please refer
              to the product packaging for the most up-to-date ingredients list
              and be aware that it may change or vary from time to time. For any
              concerns please seek professional advice before use.
            </div>
          </section>
        )}
      </SEOFriendlyDrawer>
    </>
  );
}
